export default __webpack_public_path__ + "static/media/heart.14ec3a76.svg";